import uniq from 'lodash/uniq'

import { EHR_PILLARS, useStorage } from '@/libs/storage'

const LAST_LOGIN_DATE_KEY = 'last_login_date'

export const getStoragePillars = () => {
  const { getItem } = useStorage(EHR_PILLARS)
  const data = getItem() || {}
  const pillars = Object.keys(data)
  if (!pillars.length) return undefined
  pillars.forEach(pillar => {
    data[pillar].tabs = uniq(data[pillar].tabs)
  })
  return data
}

export const setStoragePillars = pillar => {
  const { setItem } = useStorage(EHR_PILLARS)
  const data = getStoragePillars()

  setItem({
    ...data,
    ...pillar
  })
}

export const getLastLoginDate = () => {
  return localStorage.getItem(LAST_LOGIN_DATE_KEY)
}

export const setLastLoginDate = () => {
  localStorage.setItem(LAST_LOGIN_DATE_KEY, Date.now())
}
